angular.module('rjmNg.services').factory 'filterSetsPath', [
  "$rootScope"
  "$route"
  "$location"
  "$routeParams"
  "appRoute"
  "filterConstants"
  (
    $rootScope
    $route
    $location
    $routeParams
    appRoute
    filterConstants
  ) ->

    basePath = appRoute("/settings/filter-set/")

    filterSetsPathService =

      updatePath: (action, filterSetId = null) ->
        switch action
          when filterConstants.MODIFICATION_ACTIONS.CREATE then path = basePath + "create"
          when filterConstants.MODIFICATION_ACTIONS.UPDATE then  path = basePath + "#{filterSetId}"
          when filterConstants.MODIFICATION_ACTIONS.CLONE then path = basePath + "clone/#{filterSetId}"
          when filterConstants.MODIFICATION_ACTIONS.SHOWLIST then path = basePath

        lastRoute = $route.current
        onFilteSetsPage = true
        un = $rootScope.$on "$locationChangeSuccess", () ->
          if onFilteSetsPage and $location.path().match(/filter-set.*/)
            $route.current = lastRoute
            un()
          else #we are leaving the Filter Sets page, don't hang onto lastRoute
            onFilteSetsPage = false

        $location.path path

      parsePath: (entryPath) ->
        # create a filter set link was opened
        if /\/filter-set\/create$/.test(entryPath)
          return [filterConstants.MODIFICATION_ACTIONS.CREATE, null]
        # edit a filter set link was opened
        else if /\/filter-set\/\d+$/.test(entryPath)
          return [filterConstants.MODIFICATION_ACTIONS.UPDATE, +$routeParams.id]
        # clone a filter set link was opened
        else if /\/filter-set\/clone\/\d+$/.test(entryPath)
          return [filterConstants.MODIFICATION_ACTIONS.CLONE, +$routeParams.id]
        # filter set link was opened
        else if /\/filter-set\/$/.test(entryPath)
          return [filterConstants.MODIFICATION_ACTIONS.SHOWLIST, null]
        # any other links were opened
        else
          return [null, null]

]
